import { autoinject } from "aurelia-framework";
import { DialogController } from 'aurelia-dialog';
import { SessionData } from '_models/session-data';

@autoinject
export class LocationDialog {

    constructor(
        public controller: DialogController,
        public sd: SessionData) {
    }

    locationName: string = '';

    activate(model) {
        this.locationName = model;
    }

    ok() {
        if (this.locationName == '')
            return;

        // Validate
        var exists = this.sd.locations.some(l => l.toLowerCase() == this.locationName.toLowerCase());
        if (exists) {
            // TODO: Implement validation framework
            alert('Location already exists');
            return;
        }

        this.controller.ok(this.locationName);
    }

    cancel() {
        this.controller.cancel()
    }
}
